import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-liste-demandes',
  templateUrl: './liste-demandes.component.html',
  styleUrls: ['./liste-demandes.component.scss'],
  styles: [`
      :host ::ng-deep .p-button {
          margin: 0 .5rem 0 0;
          min-width: 7rem;
          background-color: #f2edf3;
          border: solid 2px #9c31b5;
          color: #9c31b5;
          height: 35px;
      }

      p {
          margin: 0;
      }

      .confirmation-content {
          display: flex;
          align-items: center;
          justify-content: center;
      }

      :host ::ng-deep .p-dialog .p-button {
          min-width: 6rem;
      }
  `]
})
export class ListeDemandesComponent implements OnInit {

  displayMaximizable: boolean;


  constructor() { }

  ngOnInit(): void {

    }

  showMaximizableDialog() {
    this.displayMaximizable = true;
}



}
